export const exchangeRates2022 = {
  disclaimer: 'Usage subject to terms: https://openexchangerates.org/terms',
  license: 'https://openexchangerates.org/license',
  timestamp: 1672531173,
  base: 'USD',
  rates: {
    AED: 3.67265,
    AFN: 87.499995,
    ALL: 107.15,
    AMD: 393.73154,
    ANG: 1.802385,
    AOA: 503.691,
    ARS: 177.136,
    AUD: 1.4695,
    AWG: 1.8,
    AZN: 1.7,
    BAM: 1.834694,
    BBD: 2,
    BDT: 103.159197,
    BGN: 1.827155,
    BHD: 0.37658,
    BIF: 2062,
    BMD: 1,
    BND: 1.345463,
    BOB: 6.910305,
    BRL: 5.2867,
    BSD: 1,
    BTC: 0.000060511315,
    BTN: 82.580061,
    BWP: 12.794278,
    BYN: 2.524226,
    BZD: 2.01584,
    CAD: 1.35695,
    CDF: 2030,
    CHF: 0.924533,
    CLF: 0.03075,
    CLP: 848.25,
    CNH: 6.9282,
    CNY: 6.8979,
    COP: 4828.102895,
    CRC: 584.108955,
    CUC: 1,
    CUP: 25.75,
    CVE: 103.55,
    CZK: 22.5693,
    DJF: 177.5,
    DKK: 6.9477,
    DOP: 56.25,
    DZD: 137.179376,
    EGP: 24.7195,
    ERN: 15,
    ETB: 53.65,
    EUR: 0.932271,
    FJD: 2.2205,
    FKP: 0.826583,
    GBP: 0.826583,
    GEL: 2.7,
    GGP: 0.826583,
    GHS: 8.347259,
    GIP: 0.826583,
    GMD: 61.95,
    GNF: 8770,
    GTQ: 7.84819,
    GYD: 209.232695,
    HKD: 7.81325,
    HNL: 24.7,
    HRK: 7.0422,
    HTG: 146.703253,
    HUF: 373.38,
    IDR: 15538.5,
    ILS: 3.5262,
    IMP: 0.826583,
    INR: 82.7696,
    IQD: 1460.5,
    IRR: 41850,
    ISK: 141.55,
    JEP: 0.826583,
    JMD: 151.711898,
    JOD: 0.7093,
    JPY: 131.11504184,
    KES: 123.5,
    KGS: 85.68,
    KHR: 4118.5,
    KMF: 460.224482,
    KPW: 900,
    KRW: 1261.910033,
    KWD: 0.305435,
    KYD: 0.833419,
    KZT: 462.856977,
    LAK: 17342.5,
    LBP: 1522.5,
    LKR: 364.752376,
    LRD: 154.450017,
    LSL: 17.01,
    LYD: 4.825,
    MAD: 10.43875,
    MDL: 19.131518,
    MGA: 4480,
    MKD: 57.724919,
    MMK: 2100.16369,
    MNT: 3406.965265,
    MOP: 8.027878,
    MRU: 36.85,
    MUR: 43.949999,
    MVR: 15.405,
    MWK: 1024.5,
    MXN: 19.4819,
    MYR: 4.405,
    MZN: 63.850001,
    NAD: 17.01,
    NGN: 448.08,
    NIO: 36.4,
    NOK: 9.771675,
    NPR: 132.128343,
    NZD: 1.575052,
    OMR: 0.384991,
    PAB: 1,
    PEN: 3.804,
    PGK: 3.52,
    PHP: 55.679993,
    PKR: 226.55,
    PLN: 4.38165,
    PYG: 7332.94607,
    QAR: 3.64075,
    RON: 4.6193,
    RSD: 109.441576,
    RUB: 73.75,
    RWF: 1070,
    SAR: 3.758788,
    SBD: 8.278288,
    SCR: 13.405776,
    SDG: 572,
    SEK: 10.4273,
    SGD: 1.340586,
    SHP: 0.826583,
    SLL: 17665,
    SOS: 569.5,
    SRD: 31.809,
    SSP: 130.26,
    STD: 22823.990504,
    STN: 23.3,
    SVC: 8.751124,
    SYP: 2512.53,
    SZL: 17.01,
    THB: 34.530369,
    TJS: 10.196018,
    TMT: 3.5,
    TND: 3.124,
    TOP: 2.341265,
    TRY: 18.6858,
    TTD: 6.796026,
    TWD: 30.662698,
    TZS: 2332,
    UAH: 36.856003,
    UGX: 3720.224466,
    USD: 1,
    UYU: 39.974162,
    UZS: 11225,
    VES: 16.78175,
    VND: 23640,
    VUV: 118.044,
    WST: 2.69755,
    XAF: 611.529402,
    XAG: 0.04172754,
    XAU: 0.00054829,
    XCD: 2.70255,
    XDR: 0.751548,
    XOF: 611.529402,
    XPD: 0.00055737,
    XPF: 111.249471,
    XPT: 0.00093229,
    YER: 250.299958,
    ZAR: 17.02291,
    ZMW: 18.111181,
    ZWL: 322,
  },
};
